import {Link, locationShape, routerShape, withRouter} from 'react-router';
import React from 'react';
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';

import Go from 'spa/Components/Go';
import LoginForm from 'spa/Components/Session/LoginForm';
import {withI18n, withConfig} from 'spa/Components/Context';
import DocumentTitle from 'spa/Components/DocumentTitle';
import { parseMultipleQueryParams} from 'spa/utils';
import PlatformStoreLogos from 'spa/Components/PlatformStoreLogos';
import AppInstallBannerLogin from 'spa/Pages/AppInstallBanner/AppInstallBannerLogin';

import './Login.less';

@withRouter
@inject(({
  store: {
    session,
    tracker,
    deviceDetection,
  },
}) => (
  {
    session,
    tracker,
    deviceDetection,
  }
))
@observer
@withI18n
@withConfig
class LoginPage extends React.Component {
  static propTypes = {
    session: PropTypes.shape({
      login: PropTypes.func.isRequired,
      isVerificationChallengeRequired: PropTypes.bool.isRequired,
      isLoading: PropTypes.bool.isRequired,
      error: PropTypes.any,
      loginResponse: PropTypes.any,
      user: PropTypes.any,
      resetLogin: PropTypes.func.isRequired,
    }).isRequired,
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    location: locationShape.isRequired,
    router: routerShape.isRequired,
    deviceDetection: PropTypes.shape({
      init: PropTypes.func.isRequired,
      platform: PropTypes.string.isRequired,
      adjustUrl: PropTypes.string.isRequired,
      isMobile: PropTypes.bool.isRequired,
      isIOS: PropTypes.bool.isRequired,
      isAndroid: PropTypes.bool.isRequired,
    }).isRequired,
  };

  componentDidMount() {
    this.props.deviceDetection.init('locale.adjust-app-login-signup-url');
  }

  handleInstall = () => {
    const {
      tracker,
      deviceDetection: {
        adjustUrl,
        platform,
      },
    } = this.props;

    tracker.track('Clicked App Install Banner In Login Screen', {
      category: 'App install banner',
      platform,
    });

    setTimeout(() => {
      window.open(adjustUrl, '_blank');
    }, 300);
  };


  render() {
    const {handleInstall} = this;
    const {i18n} = this.context;
    const {
      router,
      location,
      deviceDetection: {isIOS, isAndroid, isMobile},
      session: {
        isVerificationChallengeRequired,
        loginResponse,
        user,
      },
    } = this.props;
    const signupLink = `/${i18n.lc}/signup?${parseMultipleQueryParams(location.query)}`;
    let goElem;

    if (loginResponse || user) {
      let returnLocation = router.createLocation(location.query && location.query.returnUrl && decodeURIComponent(location.query.returnUrl) || `/${i18n.lc}/`);

      if (location.query && location.query.promocode) {
        returnLocation.query.promocode = location.query.promocode;
      }

      if (loginResponse && loginResponse.user && loginResponse.user.meta && loginResponse.user.meta.block) {
        returnLocation = router.createLocation(`/${i18n.lc}/account-blocked`);
      }

      if (location.query && location.query.return_sso_url) {
        returnLocation = router.createLocation(decodeURIComponent(location.query.return_sso_url) || `/${i18n.lc}/`);
        goElem = <Go to={router.createHref(returnLocation)} forceReload />;
      } else {
        returnLocation.query.message = 'loggedin';
        goElem = <Go to={router.createHref(returnLocation)} forceReload />;
      }
    }

    return (
      <div className="dark v-container text-center">
        {goElem}
        <DocumentTitle title={i18n._x('Sign in', '<title>')} />
        <div className="container">
          <div className="login-page__wrapper">
            <div className="login-page__form-container">
              <div className="login-page__container">
                <div className="row login-page__top-section">
                  <div className="col-xs-6 login-page__top-left-tab">
                    <span
                      className="login-page__top-link login-page__top-link--active">
                      {i18n._x('Sign in', 'Login page')}
                    </span>
                  </div>
                  <div className="col-xs-6 login-page__top-right-tab">
                    <Link
                      className="login-page__top-link"
                      data-qa="nav-bar-link-signup"
                      to={signupLink}
                    >
                      {i18n._x('Register', 'Login page')}
                    </Link>
                  </div>
                </div>
                {!isVerificationChallengeRequired &&
                <div className="container">
                  <PlatformStoreLogos
                    ios={isIOS}
                    android={isAndroid}
                    onClick={handleInstall}
                  />
                  <p>
                    {i18n._x("Don't have an account?", 'Login form title')}
                    <br />
                    <Link className="link" to={signupLink}>
                      {i18n._x('Click here to set up an account', 'Login form signup link')}
                    </Link>
                  </p>
                </div>
                }
                <div className="container container--medium">
                  <LoginForm trackingCategory="Login page" />
                  {!isVerificationChallengeRequired &&
                  <React.Fragment>
                    <div className="row row--with-gutter">
                      <div className="col-xs-6">
                        <p className="text-info text-info--byline text-end">
                          <Link className="link" to={`/${i18n.lc}/reset-password`}>
                            {i18n._x('Forgot Password?', 'Login form forgot password link')}
                          </Link>
                        </p>
                      </div>
                      <div className="col-xs-6">
                        <p className="text-info text-info--byline text-start">
                          <Link className="link" to={signupLink}>
                            {i18n._x('Create Account', 'Login form signup link')}
                          </Link>
                        </p>
                      </div>
                    </div>
                  </React.Fragment>
                  }
                </div>
              </div>
            </div>
            {!isMobile &&
            <div className="login-page__app-install-container">
              <AppInstallBannerLogin />
            </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./spa/Pages/Login.jsx